module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.showTimeString) ? _c('span', [_vm._v(_vm._s(_vm.timeString))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vux-clocker-tpl"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8fd20768"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/clocker/index.vue
// module id = 598
// module chunks = 0